import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import { createCheckoutSession } from '../../services/stripe/api/checkout';
import { StripeServiceError, STRIPE_ERROR_MESSAGES } from '../../services/stripe/errors/types';
import type { SubscriptionPlan } from '../../types/subscription';

export function usePlanSelection() {
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handlePlanSelection = async (plan: SubscriptionPlan) => {
    if (!user) {
      navigate('/login');
      return;
    }

    if (isProcessing) return;

    try {
      setIsProcessing(true);

      // Handle free plan
      if (plan.price === 0) {
        navigate('/community');
        return;
      }

      if (!plan.stripe_price_id) {
        throw new StripeServiceError(STRIPE_ERROR_MESSAGES.INVALID_PLAN);
      }

      const { url } = await createCheckoutSession(plan.stripe_price_id);
      window.location.href = url;
    } catch (error) {
      console.error('Plan selection error:', error);
      const message = error instanceof StripeServiceError 
        ? error.message 
        : STRIPE_ERROR_MESSAGES.DEFAULT;
      toast.error(message);
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    isProcessing,
    handlePlanSelection
  };
}